export default __webpack_public_path__ + "static/media/sound_entertaiment.4142de60.png";